class RacedaysPageController {

  constructor(RacedaysService, AlertService, LoaderService) {
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.getFromServer();
  }

  filterPast() {
    var self = this;
    self.filtered = true;

    // shim for old browsers
    if (!Date.now) {
      Date.now = function() { return new Date().getTime(); }
    }
    // get current time in seconds
    var now = Math.floor(Date.now() / 1000);

    self.racedays = self.racedays.filter(function(day){
      return day.date <= now;
    });
  }

  clearFilter() {
    var self = this;
    self.filtered = false;
    self.getFromServer();
  }

  getFromServer() {
    var self = this;
    self.LoaderService.start();
    self.RacedaysService.getAll()
        .then( (racedays) => self.racedays = racedays)
        .catch( (error) => self.AlertService.error("There was a problem getting the racedays"))
        .finally( ()=> self.LoaderService.stop() );
  }

}
RacedaysPageController.$inject = ['RacedaysService', 'AlertService', 'LoaderService'];
export default RacedaysPageController;
